module.exports = __webpack_public_path__ + "img/Silverado2.9c7babe9.png";